/**
 * Created by vblanco on 08/06/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Tipologia', Tipologia);

    /* @ngInject */
    function Tipologia($resource) {
        return $resource('api/admin/tipologia/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/tipologia/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/tipologia/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/tipologia/findAll'
            }
        });
    }
})();
